export default {
  id: 5,
  title: 'Target #5 - Acid Rain',
  url: 'https://cssbattle.dev/play/5',
  colors: ['#0B2429', '#F3AC3C', '#998235'],
  solution:
    '<a a><a b><style>body{background:#0B2429}a{position:fixed;width:120;height:120;background:#F3AC3C;border-radius:50%}a[a]{top:30;right:80}a[b]{bottom:30;left:80;box-shadow:60px -60px #998235;border-top-right-radius:0}</style>',
}
